/* eslint-disable no-template-curly-in-string */

import { CardFileUploaded, Typography } from 'components'
import { CardAlert } from 'components/cadFileUploaded/cardAlert'
import {
	DocumentsInputs,
	Icons,
	PeopleMyTagsParentItem,
	TypographyTypes
} from 'interfaces'
import React from 'react'

interface StepTwoOrgProps {
	fileUploaded: boolean
	selectedTags: PeopleMyTagsParentItem[]
	steps: string
	documentUpload: DocumentsInputs | undefined
	fileSize: number
	fileSizeUnit: string
}

export const StepTwoOrg: React.FC<StepTwoOrgProps> = ({
	fileUploaded,
	selectedTags,
	steps,
	documentUpload,
	fileSize,
	fileSizeUnit
}) => {
	const infoAdditionalTag = (
		hidden: boolean,
		requiredApproval: boolean
	): JSX.Element => {
		return (
			<div className="fle flex-col">
				{!hidden && (
					<Typography
						className="text-gray-1"
						title="(Hidden)"
						fontLeading="12/16"
						type={TypographyTypes.p}
					/>
				)}
				{requiredApproval && (
					<Typography
						title="(Approval required)"
						fontLeading="12/16"
						type={TypographyTypes.p}
						className="text-gray-1"
					/>
				)}
			</div>
		)
	}
	const styleTagSelect =
		'border-blue-primary border-solid border-[1px] rounded-2xl w-full p-2 mb-2'

	return (
		<div className="flex flex-col justify-start w-full items-start gap-4 h-[38rem]">
			<Typography
				title={steps}
				fontLeading="14/24"
				type={TypographyTypes.h1}
				className="text-black font-medium text-lg"
			/>
			<Typography
				title="Review your file and confirm the import to complete the process. "
				fontLeading="14/24"
				type={TypographyTypes.p}
				className="text-black font-normal text-base"
			/>
			<Typography
				title="CSV files:"
				fontLeading="14/24"
				type={TypographyTypes.h1}
				className="text-black font-medium text-lg"
			/>
			{fileUploaded && (
				<CardFileUploaded
					nameFile={documentUpload?.name_file || ''}
					size={fileSize}
					unit={fileSizeUnit}
				/>
			)}
			<Typography
				title="Tags:"
				fontLeading="14/24"
				type={TypographyTypes.h1}
				className="text-black font-medium text-lg"
			/>
			<div className="flex flex-col w-full h-auto border-[1px] border-solid border-blue-primary rounded-lg p-4 overflow-y-auto">
				{selectedTags.map((tag, index) => {
					return (
						<div key={`${tag.organization_tag_parent_id}_${index}`}>
							{tag.subRows && tag.subRows.length > 0 ? (
								tag.subRows.map(subTag => (
									<div
										key={subTag.organization_tag_id}
										className={styleTagSelect}
									>
										<Typography
											title={`${tag.name}`}
											fontLeading="14/24"
											type={TypographyTypes.p}
											className="text-black font-bold text-base"
										/>
										<Typography
											title={`${subTag.name}`}
											fontLeading="14/24"
											type={TypographyTypes.p}
											className="text-black font-normal text-base"
										/>

										{infoAdditionalTag(
											subTag.is_visible,
											subTag.required_approval
										)}
									</div>
								))
							) : (
								<div
									key={`${tag.organization_tag_parent_id}_${index}_div`}
									className={styleTagSelect}
								>
									<Typography
										title={tag.name || ''}
										fontLeading="14/24"
										type={TypographyTypes.p}
										className="text-black font-bold text-base"
									/>
									{infoAdditionalTag(tag.is_visible, tag.required_approval)}
								</div>
							)}
						</div>
					)
				})}
			</div>
			<CardAlert
				title="Important!"
				description="Once finished, new users in the spreadsheet will be created in the platform, existing ones will be updated with the spreadsheet information."
				icon={Icons.assignmentInd}
			/>
		</div>
	)
}
